import React, { useRef, useMemo, useState, useEffect, useContext } from 'react'
import JoditEditor from 'jodit-react';
import { Button } from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2'
import { SchoolContex } from '../../Helper/Contex';

const AddEventForm = (props) => {

    const { schools } = useContext(SchoolContex)

    const [data, setData] = useState({
        event: '',
        date: '',
        school: '',
        location: '',
    })
    const [image, setImg] = useState();
    const [icon, setIcon] = useState();
    const [details, setDetails] = useState();
    const [load, setLoad] = useState(false);
    const [test , setTest]  = useState(0);

    const handleInput = (e) => {
        setData({
            ...data, [e.target.name]: e.target.value
        })
    }

    const handleImg = (e) => {
        if (e.target.name === 'icon') {
            setIcon(e.target.files[0])
            // console.log("icon");

        }
        if (e.target.name === 'image') {
            setImg(e.target.files[0]);
            // console.log('image');

        }
    }

    const handleDetails = (e) => {
        setDetails(e)
    }

    // jodit editor
    const editor = useRef(null);

    const config = {
        uploader: {
            insertImageAsBase64URI: true
        },
        height: 320,
        triggerChangeEvent: true,
        readonly: false,
    }

    const Details = () => {
        return useMemo(() => (
            <JoditEditor
                // ref={editor}
                config={config}
                value={details}
                onChange={handleDetails}
            />
        ), [test])
    }


    const saveEvent = () => {
        setLoad(true)
        const postData = new FormData();
        if (props?.modalData.id) {
            postData.append('id', props?.modalData.id)
        }
        postData.append('event', data.event)
        postData.append('icon', icon)
        postData.append('image', image)
        postData.append('details', details)
        postData.append('school', data.school)
        postData.append('location', data.location)
        postData.append('date', data.date)

        axios.post(`${process.env.REACT_APP_MAIN_API}saveEvent`, postData)
            .then((res) => {
                // console.log(res);
                props.handleClose();
                setLoad(false)
                Swal.fire({
                    title: 'Success!',
                    text: 'Added Succeffully !',
                    icon: 'success',
                    confirmButtonText: 'Ok'
                })

            })
            .catch((err) => {
                // console.log(err.response);
                Swal.fire({
                    title: 'Error!',
                    text: 'Something went wrong !',
                    icon: 'error',
                    confirmButtonText: 'Ok'
                })

            })

    }

    const newTest = () => {
        setDetails(props.modalData.details)
    }
     useEffect(() => {
         setTest(test + 1)
         setData(props.modalData)
         newTest();
     },[props])

    //  console.log(props ,'propspropsprops');

    return (
        <>
            <div className='row'>

                <div className='col-md-12 p-2'>
                    <label htmlFor="">Event Name:</label>
                    <input type="text" className='form-control' name="event" value={data.event} onChange={handleInput} id="" />
                </div>

                <div className='col-md-6 p-2'>
                    <label htmlFor="">Event Date:</label>
                    <input type="date" className='form-control' name="date" value={data.date} onChange={handleInput} id="" />
                </div>

                <div className='col-md-6 p-2'>
                    <label htmlFor="">School:</label>
                    {/* <input type="text" className='form-control' name="school" value={data.school} onChange={handleInput} id="" /> */}

                    <select className='form-control' name='school' value={data.school} onChange={handleInput}>
                        <option>--selest--</option>
                        {schools && schools.map((sch)=>
                        (
                            <option value={sch.schoolName}>{sch.schoolName}</option>
                        ))}
                    </select>

                </div>


                <div className='col-md-6 p-2'>
                    <label htmlFor="">Image: (Optional)</label>
                    <input type="file" className='form-control' name="image" onChange={handleImg} id="" />
                    {
                        props.modalData.image &&
                    <img src={`${process.env.REACT_APP_BACKEND}assets/events/img/${props.modalData.image}`} height={50} className='m-2' />
                    }
                </div>
                {/* <div className='col-md-6 p-2'>
                    <label htmlFor="">Icon: (Optional)</label>
                    <input type="file" className='form-control' name="icon" onChange={handleImg} id="" />
                    {
                        props.modalData.icon &&
                    <img src={`${process.env.REACT_APP_BACKEND}assets/events/icon/${props.modalData.icon}`} height={50} className='m-2' />
                    }
                </div> */}
                <div className='col-md-6 p-2'>
                    <label htmlFor="">Location (Optional)</label>
                    <input type="text" className='form-control' name="location" value={data.location} onChange={handleInput} id="" />
                   
                </div>

                <div className='col-md-12 p-2'>
                    <label htmlFor="">Details:</label>
                    {Details()} 
                    {/* {test} */}
                </div>
                <div className='col-md-12 p-4 text-center'>
                    <Button variant='contained' disabled={load ? true : false} onClick={saveEvent}>Save Event</Button>
                </div>

            </div>
        </>
    )
}

export default AddEventForm;